import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Car } from "lucide-react";
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-secondary via-background to-muted p-4">
      <div className="text-center space-y-6 max-w-md">
        <div className="h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto">
          <Car className="h-8 w-8 text-primary" />
        </div>
        <div className="space-y-2">
          <h1 className="text-6xl font-bold text-foreground">{t('notFound.title')}</h1>
          <p className="text-2xl font-semibold text-foreground">{t('notFound.subtitle')}</p>
          <p className="text-muted-foreground">
            {t('notFound.description')}
          </p>
        </div>
        <Button asChild size="lg" className="h-touch">
          <Link to="/">{t('notFound.returnHome')}</Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
